/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetCostumeTypeService,
  IGetCostumeTypeMethods,
  ModifyOrderService,
  IModifyOrderTypeMethods,
} from "./components";

export type ChangeCostumeOptionsPageAgent = IStaticPageContentMethods &
  IGetCostumeTypeMethods &
  IModifyOrderTypeMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new GetCostumeTypeService(),
    new ModifyOrderService(),
  ];
};

export const getAgent = () => {
  return createAgent<ChangeCostumeOptionsPageAgent>({
    plugins: getPlugins(),
  });
};
